export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5275.7775b5d8.jpg";